import React, { useState } from 'react'
import { Button, Col, Space, Form } from 'antd'
import {
    successNotification,
    carsUrl,
    postRequest,
    errorNotification
} from '../../config'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

const BulkUploadForm = props => {
    const car = props.car
    const [images, setImages] = useState([])
    const [loading, setLoading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0)

    const handleImageChange = event => {
        setImages(Array.from(event.target.files))
    }

    const handleSubmit = async event => {
        event.preventDefault()
        if (images.length === 0) {
            errorNotification('Please select at least one image.')
            return
        }

        setLoading(true)
        let successCount = 0
        let errorCount = 0

        for (let i = 0; i < images.length; i++) {
            const formData = new FormData()
            formData.append('image', images[i])
            // Default values for required fields
            formData.append('is_showcase_image', false)
            formData.append('active', true)
            formData.append('is_video', false)
            formData.append('video_id', '')

            const response = await postRequest(
                `${carsUrl}/${car.id}/add-image`,
                formData,
                'image',
                () => { }, // We handle loading state manually
                false
            )

            if (response.success) {
                successCount++
            } else {
                errorCount++
            }
            setUploadProgress(((i + 1) / images.length) * 100)
        }

        setLoading(false)
        if (successCount > 0) {
            successNotification(`${successCount} images uploaded successfully.`)
        }
        if (errorCount > 0) {
            errorNotification(`${errorCount} images failed to upload.`)
        }
        props.handleCancel()
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <Form className="p-2rem" layout="vertical">
                        <div className="row">
                            <div
                                className="col-md-12"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    marginBottom: '20px'
                                }}
                            >
                                <label style={{ marginBottom: '10px' }}>Select Images (Multiple allowed)</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleImageChange}
                                    required
                                    className="form-control"
                                    style={{ padding: '10px', marginBottom: '20px' }}
                                />
                                <div style={{ marginTop: '10px' }}>
                                    {images.length > 0 && <span>{images.length} files selected</span>}
                                </div>
                            </div>

                            {loading && (
                                <div className="col-md-12" style={{ marginBottom: '20px' }}>
                                    <div className="progress">
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{ width: `${uploadProgress}%` }}
                                            aria-valuenow={uploadProgress}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        >
                                            {Math.round(uploadProgress)}%
                                        </div>
                                    </div>
                                </div>
                            )}

                            <Col md={24}>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end',
                                        marginBottom: '20px'
                                    }}
                                >
                                    <Space>
                                        <Button
                                            type="primary"
                                            onClick={handleSubmit}
                                            loading={loading}
                                            disabled={images.length === 0}
                                        >
                                            Upload All
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

BulkUploadForm.propTypes = {
    car: PropTypes.object,
    handleCancel: PropTypes.func
}

export default withRouter(BulkUploadForm)
